import { createSelector } from 'reselect';
import { studySpoTrainingSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const studySpoTrainingYearsSelector = createSelector(studySpoTrainingSelector, (studySpoTraining) =>
  extractDatesFromNestedItems(studySpoTraining?.content, [
    {
      type: 'academicYearString',
      field: 'learningYear',
    },
  ]),
);
